import clsx from "clsx"
import { ReactNode } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { colors } from "../../color"
import { BreadcrumbsIcon } from "../../icons/breadcrumbIcon"
import { CloseLogoIcon } from "../../icons/closeLogoIcon"
import { Logo } from "../../icons/logoIcon"
import { MenuStatus } from "../../layout/dto"
import { setMenuStatus } from "../../layout/slice"
import { MenuItems, MenuItemsHrefMap, menuItemsIconMap, MenuItemsLabelMap } from "./dto"
import NavLinks from "./nav-links"

export default function SidebarComponent(props: { menuItem: MenuItems }) {
  const { menuItem } = props

  const dispatch = useAppDispatch()

  const layoutState = useAppSelector(state => state.layout)

  let logo: ReactNode[] = []

  if (layoutState.menuStatus === MenuStatus.CLOSED) {
    logo.push(
      <CloseLogoIcon />
    )
  } else {
    logo.push(
      <Logo />
    )
  }

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: colors.pas[200], overflow: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}
        className={clsx(
          'h-[100px]',
          {
            'p-[24px] justify-between': layoutState.menuStatus !== MenuStatus.CLOSED,
            'py-[16px] lg:px-[0px] justify-center': layoutState.menuStatus === MenuStatus.CLOSED,
          }
        )}>
        {logo}
        <div
          onClick={() => {
            if (layoutState.menuStatus === MenuStatus.OPEN) {
              dispatch(setMenuStatus(MenuStatus.CLOSED))
            } else if (layoutState.menuStatus === MenuStatus.HOVER) {
              dispatch(setMenuStatus(MenuStatus.OPEN))
            }
          }}
          className={
            clsx(
              'transition-all cursor-pointer hidden',
              {
                'rotate-0 lg:block': layoutState.menuStatus === MenuStatus.OPEN,
                'rotate-180 lg:block': layoutState.menuStatus === MenuStatus.HOVER,
                'hidden': layoutState.menuStatus === MenuStatus.CLOSED
              }
            )
          }>
          <BreadcrumbsIcon />
        </div>
      </div>
      {
        layoutState.menuItems.map((item) => (
          <div key={MenuItemsLabelMap.get(item.item)} className={"flex flex-col items-start justify-start px-4 py-1"}>
            <NavLinks
              menuItem={menuItem}
              link={
                {
                  href: MenuItemsHrefMap.get(item.item),
                  name: MenuItemsLabelMap.get(item.item),
                  icon: menuItemsIconMap.get(item.item),
                  menuItem: item.item
                }
              }
            />
          </div>
        ))
      }
      <div
        style={{ padding: '24px 16px 24px 16px', height: '100%', display: 'flex', justifyContent: 'start', alignItems: 'flex-end' }}
        className='text-label-sm font-medium text-neutral-500 transition-all'
      >
        <span
          className={
            clsx(
              'transition-all',
              {
                "block": layoutState.menuStatus === MenuStatus.CLOSED,
                "hidden content-['© 2024 Passeggero Al Sicuro']": layoutState.menuStatus !== MenuStatus.CLOSED
              }
            )
          }>
          ©
        </span>
        <div className='flex flex-col gap-6 w-full'>
          <span
            className={
              clsx(
                'transition-all',
                {
                  "hidden": layoutState.menuStatus === MenuStatus.CLOSED,
                  "block": layoutState.menuStatus !== MenuStatus.CLOSED
                }
              )
            }>
            © {new Date().getFullYear()} Passeggero Al Sicuro
          </span>
        </div>
      </div>
    </div>
  );
}
